import React, {Component, useRef} from "react";
import Header4 from "../../Header/Header4";
import "./index.css";
import {Button, message, Layout, Menu, Tooltip, Modal} from "antd";
import {connect} from "react-redux";
import data from './data.json'
import {DownloadOutlined, FilePdfOutlined} from "@ant-design/icons";
import RotatingEarth from "./RotatingEarth";

class Presentation extends Component {
    state = {}


    // earthRef = useRef(null);
    componentDidMount() {

    }

    toPresentationDetail = (id) => {
        this.props.history.push({
            pathname: '/Presentation/PresentationDetail',
            search: `?id=${id}`
        });
    }

    render() {
        return <div className="pre_bg">
            <div className="pre_bg_image">
                <div className="pre_header">
                    <div className="pre_header_title_text">
                        陆地观测卫星共性应用支撑平台
                        <div
                            className="pre_header_title_en_text">{"Common application support platform for land observation satellite"}</div>
                    </div>
                </div>
                <div className="system_group_out_line">
                <div className="system_group_line">
                    <div className="system_group_font">真实性检验场网系统</div>
                    <div className="system_group_font">共性应用技术支撑服务系统</div>
                </div></div>
                <div className="pre_body">
                    <div className="pre_body_left">
                        {
                            data.map(item => item.id <= 4 ?
                                <div key={item.id} className="subsystem_item left-top rightTop border"
                                     onClick={() => this.toPresentationDetail(item.id)}>
                                    <div className="subsystem_item_title_left_box">
                                        <div className="subsystem_item_title">{item.subsystemName}</div>
                                        <div className="subsystem_item_title_before"></div>
                                    </div>
                                </div> : null
                            )
                        }
                    </div>
                    <div className="pre_body_center"><RotatingEarth/></div>
                    <div className="pre_body_right">
                        {
                            data.map(item => item.id > 4 ?
                                <div key={item.id} className="subsystem_item left-top rightTop border"
                                     onClick={() => this.toPresentationDetail(item.id)}>
                                    <div className="subsystem_item_title_right_box">
                                        <div className="subsystem_item_title">{item.subsystemName}</div>
                                        <div className="subsystem_item_title_before"></div>
                                    </div>
                                </div> : null
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    }

}

const mapState = (state) => ({
    loginObj: state.userReducer.get("loginObj").toJS(),
    user: state.userReducer.get("user").toJS(),
});
const mapDispatch = (dispatch) => ({});

export default connect(mapState, mapDispatch)(Presentation);